import { Formik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Jumbotron, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import * as Yup from 'yup';
import Post from "../../api/Post";
import { GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN, SCHEDULE_DINAMIC_BY_SPECIALITY } from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";
import { getTokenExternal } from "../../utils/getTokenExternal";
import SelectAjax from "../SelectAjax";

function StepTwoAutoagendamientoMexico({t, next, initialData, setInitialData, prev, speciality, setShowModalError, setErrorServer, linkAllianz}){
    const [especialidad, setEspecialidad] = useState(speciality ? {label: speciality.name, value: speciality.id} : null)
    const [horario, setHorario] = useState(null)
    const [isSearch, setIsSearch] = useState(false)
    const [fecha, setFecha] = useState(new Date())
    const [startDay, setStartDay] = useState(0)
    const [indexSelectHor, setIndexSelectHor] = useState(null)
    const link = linkAllianz ? linkAllianz : false

    useEffect(()=>{
        //console.log(especialidad)
        if(especialidad){
            let mounted= true;
            setIsSearch(true)
            getTokenExternal()
            .then(response=>{
                if(mounted){
                    let url = `${SCHEDULE_DINAMIC_BY_SPECIALITY}?specialityId=${especialidad.value}&dateIni=${moment(fecha).format("DD-MM-YYYY")}&dateEnd=${moment(fecha).format("DD-MM-YYYY")}&accountId=${initialData.account.id}&link=${link}`
                    Post({url: url, data:{}, access_token: response.data.access_token, header: true})
                    .then(respD=>{
                        if(Object.keys(respD.data.data.response).length > 0){                    
                            let keys = Object.keys(respD.data.data.response)
                            let obj = {
                                key: keys[0],
                                value: respD.data.data.response[keys[0]]
                            }                    
                            setHorario(obj)
                        }else{
                            let obj = {
                                key: moment(fecha).format("YYYY-MM-DD"),
                                value: []
                            }
                            setHorario(obj)
                        }                        
                        setIsSearch(false)
                    })
                    .catch(errD => {
                        setHorario(null)
                        setIsSearch(false)
                        setShowModalError(true)
                        if(errD.response){
                            setErrorServer(errD.response)
                        }
                    })
                }
            })
            .catch(error=>{
                setHorario(null)
                setIsSearch(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
            return () => mounted = false;
        }
    }, [fecha, especialidad])



    const handleSubmit = (values) =>{
        next(values)
    }

    const shemaValidateStepOne = Yup.object().shape({
        hourInit: Yup.string()
           .required(t('Camporequerido'))
    });

    const minusDay = n =>{
        let nDays = startDay-n
        setStartDay(nDays) 
        let newFecha = moment(fecha)
        newFecha.subtract(n, 'days')    
        setFecha(newFecha)    
        setIndexSelectHor(null)             
    }

    const plusDay = n =>{
        let nDays = startDay+n
        setStartDay(nDays)        
        let newFecha = moment(fecha)
        newFecha.add(n, 'days')    
        setFecha(newFecha)   
        setIndexSelectHor(null)    
    }

    const selectTime = (it, i) =>{
        setIndexSelectHor(i)
        let schedule = {
            scheduleType:"Online",
            doctor:null,
            hourInit: moment(it.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            candidateDoctors: it.doctors.map(e=>e.id) 
        }
        setInitialData(prev=>({
            ...prev,
            hourInit: moment(it.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            schedule: schedule,
            doctorName: ``,
            especialidadName: especialidad.label,
            especialidadId: especialidad.value
        }))
    }


    return (
        <Formik
            initialValues={initialData}
            validationSchema={shemaValidateStepOne}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >{({
            errors,
            handleSubmit,
            setFieldValue
        })=>(
            <Form onSubmit={handleSubmit}>
                <Card className="mb-3">
                    <Card.Body>
                        { 
                            errors.hourInit && 
                            <Alert variant="danger">{t('seleccionar_horario')}</Alert> 
                        }
                        {
                            initialData.schedule &&
                            <div className="alert-info p-3 rounded">
                                <label>{t('cita_seleccionada')}</label>
                                <h6 className="mb-0">{t('fecha')}: {moment(initialData.schedule.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")} hrs</h6>
                            </div>                            
                        }
                        {
                            !speciality &&
                            <Row className="mb-3">
                                <Col>
                                <Form.Group className="w-50 m-auto">
                                    <Form.Label className="text">{t('filtrar_especialidad')}</Form.Label>
                                    <SelectAjax
                                        defaultValue={especialidad === null || Object.keys(especialidad).length === 0 ? false : especialidad}
                                        url={`${GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN}/${initialData.account.id}`}
                                        access_token={null}
                                        isMulti={false}
                                        handleChange={(value) => setEspecialidad(value)} 
                                        defaultOptions={especialidad}   
                                        valid={true}     
                                        isClearable={false}
                                        className="rounded"
                                        placeholder="Selecciona la especialidad para tu cita"    
                                        noToken={true}                                               
                                    />
                                </Form.Group> 
                                </Col>
                            </Row>
                        }
                        {
                            !especialidad ?
                            <Row>
                                <Col>
                                    <Jumbotron>
                                        <p>Por favor escoger una especialidad</p>
                                    </Jumbotron>
                                </Col>
                            </Row> :
                            isSearch ?
                            <Row>
                                <Col className="position-relative overflow-hidden h-300px">
                                    <SimpleLoad />
                                </Col>
                            </Row> :
                            <Row>
                                {
                                    horario && 
                                    <Col className="text-style">
                                        <Row className="align-items-center">
                                            <Col xs="2" md="2" className="text-center">{startDay > 0 && <span className="bg-arrow" onClick={e=>minusDay(1)}><BsChevronLeft /></span>}</Col>
                                            <Col xs="2" md="8" className="text-center">
                                                <div className="text-center">
                                                    <span className="d-block font-weight-bold-600">{moment(horario.key, "YYYY-MM-DD").format("ddd")}</span>
                                                    <span className="font-size-08rem d-block">{moment(horario.key, "YYYY-MM-DD").format("DD MMM YYYY")}</span>                    
                                                </div>
                                            </Col>
                                            <Col xs="2" md="2" className="text-center">{startDay !== 7 && <span className="bg-arrow" onClick={e=>plusDay(1)}><BsChevronRight /></span>}</Col>
                                        </Row>
                                        {
                                            horario.value.length === 0 ?
                                            <Jumbotron>
                                                <h3>Lo sentimos!</h3>
                                                <p>No hay horarios disponible para la fecha seleccionada</p>
                                            </Jumbotron> :
                                            <div className="wrapper-hour mt-3">
                                                {
                                                    horario.value.map((it, i)=>(
                                                        <div 
                                                            key={i} 
                                                            className={`cursor-pointer box-hour ${i===indexSelectHor && 'box-hour-active'}`}
                                                            onClick={e=>selectTime(it, i)}
                                                        >{moment(it.hour, "HH:mm:ss").format("HH:mm")}</div>
                                                    ))
                                                }
                                            </div>
                                        }
                                        
                                    </Col>

                                }
                            </Row>
                        }
                        
                        
                        {!isSearch && <Row className="mt-3">
                            <Col className="text-right">
                                <Button type="button" variant="primary" className="btn1" onClick={prev}>{t('regresar')}</Button>{' '}
                                <Button type="submit" variant="primary" className="btn1">{t('siguiente')}</Button>
                            </Col>
                        </Row>}
                    </Card.Body>
                </Card>
            </Form>
        )}

        </Formik>
    )
}

export default withTranslation()(StepTwoAutoagendamientoMexico)